import React from 'react';
import env from '../../environment.js';

const MapLegendRow = ({ items }) => {
  if (!items.length) return null;
  return (
    <div style={{ paddingTop: 20 }}>
      <div className="d-flex flex-wrap align-items-center" style={{ gap: 20, fontSize: 13, color: env.colors.neutral_700 }}>
        {items.map((it, i) => (
          <span key={i} className="d-flex align-items-center" style={{ gap: 6, lineHeight: 1 }}>
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: it.color,
                display: 'inline-block',
                flexShrink: 0,
              }}
            />
            <span>
              {it.label} · {it.count}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default MapLegendRow;
